// Multi-step Strategy Form definition for STUDYGRI
// 8 steps, 73 fields. Field types: text | textarea | select | multi-select
// `opt` = true → field is optional and gets "(необов'язково)" suffix

export const STRATEGY_STEPS = [
  {
    title: "Загальна інформація",
    subtitle: "Розкажіть базову інформацію про учня — це стартова точка нашої стратегії.",
    fields: [
      { key: "f1_name",       label: "Ім'я та прізвище учня", type: "text", required: true },
      { key: "f2_age_class",  label: "Вік і поточний клас", type: "text", required: true },
      { key: "f3_school",     label: "Місто та назва школи", type: "text", required: true },
      { key: "f4_year",       label: "Планований рік вступу", type: "select", options: ["2026", "2027", "2028"], required: true },
      { key: "f5_who_fills",  label: "Хто заповнює анкету", type: "select", options: ["Учень", "Батьки", "Разом"], required: true }
    ]
  },
  {
    title: "Академічний профіль",
    subtitle: "Оцінки, олімпіади та академічні досягнення визначають, на які університети ми націлюємось.",
    fields: [
      { key: "f6_gpa",         label: "Середній бал атестату за останні 2 роки", type: "text" },
      { key: "f7_strong",      label: "Найсильніші предмети — перелічіть 3–5", type: "textarea" },
      { key: "f8_weak",        label: "Слабкі або складні предмети", type: "textarea" },
      { key: "f9_olympiads",   label: "Олімпіади — назва, рівень, місце", type: "textarea" },
      { key: "f10_program",    label: "Програма навчання", type: "select", options: ["Звичайна", "Поглиблена", "IB", "A-Levels", "Інше"] },
      { key: "f11_sat",        label: "SAT або ACT — результат і дата", type: "text", opt: true },
      { key: "f12_ap",         label: "AP-екзамени — предмети і бали", type: "textarea", opt: true },
      { key: "f13_tutors",     label: "Репетитори або курси зараз", type: "textarea", opt: true },
      { key: "f14_awards",     label: "Академічні нагороди та сертифікати", type: "textarea", opt: true },
      { key: "f15_dynamics",   label: "Динаміка оцінок", type: "select", options: ["Зростають", "Стабільні", "Падають"] }
    ]
  },
  {
    title: "Мовний профіль",
    subtitle: "Мовна підготовка — критична частина стратегії подачі документів.",
    fields: [
      { key: "f16_eng_level",   label: "Рівень англійської (самооцінка)", type: "select", options: ["A2", "B1", "B2", "C1", "C2"] },
      { key: "f17_cert",        label: "Офіційний сертифікат — який і бал (IELTS/TOEFL/CAE)", type: "text", opt: true },
      { key: "f18_test_when",   label: "Коли планується здача мовного тесту", type: "text" },
      { key: "f19_other_lang",  label: "Інші іноземні мови та рівень", type: "textarea", opt: true },
      { key: "f20_daily_eng",   label: "Чи спілкується англійською щодня", type: "select", options: ["Так", "Частково", "Ні"] },
      { key: "f21_abroad_exp",  label: "Досвід навчання або проживання за кордоном", type: "textarea", opt: true }
    ]
  },
  {
    title: "Активності та досягнення",
    subtitle: "Позашкільна діяльність робить профіль сильним для топ-університетів.",
    fields: [
      { key: "f22_internship",  label: "Стажування або робочий досвід", type: "textarea" },
      { key: "f23_volunteer",   label: "Волонтерський досвід", type: "textarea" },
      { key: "f24_contests",    label: "Міжнародні конкурси, олімпіади, хакатони", type: "textarea" },
      { key: "f25_projects",    label: "Власні проєкти", type: "textarea" },
      { key: "f26_publications", label: "Публікації або наукові конференції", type: "textarea", opt: true },
      { key: "f27_sport",       label: "Спортивні досягнення", type: "textarea", opt: true },
      { key: "f28_creative",    label: "Творчі досягнення (мистецтво, музика, кіно, дизайн)", type: "textarea", opt: true },
      { key: "f29_leadership",  label: "Досвід лідерства", type: "textarea" },
      { key: "f30_ace",         label: "Найпотужніший козир у профілі", type: "textarea" },
      { key: "f31_top_activity", label: "Яка активність займає найбільше часу щотижня", type: "text" },
      { key: "f32_links",       label: "LinkedIn / GitHub / Behance / Portfolio — посилання", type: "text", opt: true },
      { key: "f33_public_work", label: "Чи є публічні роботи онлайн", type: "textarea", opt: true }
    ]
  },
  {
    title: "Спеціальність та університети",
    subtitle: "Розуміння цілей допоможе побудувати список університетів (reach / target / safety).",
    fields: [
      { key: "f34_major",         label: "Бажана спеціальність або сфера", type: "textarea" },
      { key: "f35_all_majors",    label: "Усі варіанти спеціальностей, які розглядаєте", type: "textarea" },
      { key: "f36_career_path",   label: "Чи є чіткий career path", type: "select", options: ["Так", "Поки ні"] },
      { key: "f37_hobby_topic",   label: "Предмет або тема поза школою, якою захоплюєтесь", type: "textarea" },
      { key: "f38_ranking",       label: "Важливість рейтингу університету в галузі", type: "select", options: ["Критично", "Бажано", "Не важливо"] },
      { key: "f39_liberal",       label: "Розглядається Liberal Arts", type: "select", options: ["Так", "Ні", "Не знаю"] },
      { key: "f40_countries",     label: "Які країни розглядаєте", type: "multi-select", options: ["США", "UK", "Нідерланди", "Германія", "Швейцарія", "Бельгія", "Інше"] },
      { key: "f41_target_uni",    label: "Конкретні університети, що цікавлять", type: "textarea", opt: true },
      { key: "f42_excluded_uni",  label: "Університети, що виключені — і чому", type: "textarea", opt: true },
      { key: "f43_priority",      label: "Що важливіше", type: "select", options: ["Рейтинг", "Місто або країна", "Однаково"] },
      { key: "f44_stay_work",     label: "Важлива можливість залишитись працювати після навчання", type: "select", options: ["Так", "Ні", "Не знаю"] },
      { key: "f45_gap_year",      label: "Розглядається gap year", type: "select", options: ["Так", "Ні"] },
      { key: "f46_transfer",      label: "Розглядається transfer із українського вишу", type: "select", options: ["Так", "Ні"] }
    ]
  },
  {
    title: "Фінанси та стипендії",
    subtitle: "Бюджет визначає стратегію: топ-стипендії, доступні країни, освітні кредити.",
    fields: [
      { key: "f47_budget",        label: "Орієнтовний річний бюджет", type: "select", options: ["до €20k", "€20–50k", "€50k+"] },
      { key: "f48_scholarship",   label: "Стипендія як основне фінансування", type: "select", options: ["Так", "Частково", "Ні"] },
      { key: "f49_target_schol",  label: "Конкретні стипендії, що цікавлять", type: "textarea", opt: true },
      { key: "f50_loan",          label: "Можливість освітнього кредиту", type: "select", options: ["Так", "Ні", "Розглядаємо"] },
      { key: "f51_eu_ties",       label: "Громадянство або зв'язки в ЄС", type: "textarea", opt: true },
      { key: "f52_free_edu",      label: "Критично важлива безкоштовна освіта (як у Германії)", type: "select", options: ["Так", "Ні"] },
      { key: "f53_less_known",    label: "Готові розглядати менш відомий університет заради стипендії", type: "select", options: ["Так", "Ні"] }
    ]
  },
  {
    title: "Документи та рекомендації",
    subtitle: "Готовність документів впливає на терміни подачі та стратегію.",
    fields: [
      { key: "f54_diploma",       label: "Чи є атестат або ще не отриманий", type: "select", options: ["Є", "Буде у 2026", "Буде у 2027"] },
      { key: "f55_apostille",     label: "Чи є апостиль на документах", type: "select", options: ["Так", "Ні", "Не знаю"] },
      { key: "f56_passport",      label: "Паспорт — чинний", type: "select", options: ["Так", "Ні", "В процесі"] },
      { key: "f57_recommenders",  label: "Хто може написати рекомендаційний лист (вчитель, роботодавець, науковий керівник)", type: "textarea" },
      { key: "f58_years_known",   label: "Скільки років знайомі з кожним рекомендатором", type: "textarea" },
      { key: "f59_foreign_prof",  label: "Чи є контакт з іноземним науковцем або викладачем", type: "select", options: ["Так", "Ні"] },
      { key: "f60_mentor",        label: "Чи є ментор або науковий керівник зараз", type: "select", options: ["Так", "Ні"] },
      { key: "f61_research_topic", label: "Тема дослідження, якщо є", type: "textarea", opt: true }
    ]
  },
  {
    title: "Особиста історія та фінал",
    subtitle: "Ці відповіді допоможуть побудувати сильне персональне есе (motivation letter).",
    fields: [
      { key: "f62_why_abroad",    label: "Чому навчання за кордоном, а не в Україні", type: "textarea" },
      { key: "f63_influence",     label: "Яка подія або людина вплинула на вибір спеціальності", type: "textarea" },
      { key: "f64_strength",      label: "Головна перевага як особистість (не оцінки)", type: "textarea" },
      { key: "f65_challenge",     label: "Головний виклик або слабке місце в профілі", type: "textarea" },
      { key: "f66_three_words",   label: "Три слова про учня", type: "text" },
      { key: "f67_goals",         label: "Цілі на 5–10 років після університету", type: "textarea" },
      { key: "f68_unique",        label: "Що є унікальним або нестандартним у біографії", type: "textarea" },
      { key: "f69_prev_attempts", label: "Попередні спроби вступу — невдалі або вдалі", type: "textarea", opt: true },
      { key: "f70_hours_prep",    label: "Скільки годин на тиждень учень може виділити на підготовку", type: "select", options: ["до 5 год", "5–10 год", "10+ год"] },
      { key: "f71_when_start",    label: "Коли родина готова почати активну підготовку", type: "select", options: ["Зараз", "Через 1–3 місяці", "Через 3–6 місяців"] },
      { key: "f72_medical",       label: "Медичні або особисті обставини, що впливають на вибір країни", type: "textarea", opt: true },
      { key: "f73_extra",         label: "Додаткові питання або важлива інформація для STUDYGRI", type: "textarea" }
    ]
  }
];

// Contact block shown before submission
export const CONTACT_FIELDS = [
  { key: "contact_email", label: "E-mail для зв'язку", type: "text", required: true },
  { key: "contact_phone", label: "Телефон", type: "text", required: true }
];

// Total field count (for progress display)
export const TOTAL_FIELDS = STRATEGY_STEPS.reduce((n, s) => n + s.fields.length, 0);
